class CollapsibleTab extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-trigger]');
    this.content = this.querySelector('[data-content]');
  }

  connectedCallback() {
    if (!this.trigger || !this.content) return;
    
    if (this.getAttribute('open') === 'true') {
      this.content.removeAttribute('hidden');
      this.classList.add('is-open');
    }

    this.trigger.addEventListener('click', () => this.toggle());
  }

  toggle() {
    const isOpen = !this.content.hasAttribute('hidden');
    if (isOpen) {
      this.content.setAttribute('hidden', '');
      this.classList.remove('is-open');
    } else {
      this.content.removeAttribute('hidden');
      this.classList.add('is-open');
    }
  }
}

customElements.define('collapsible-tab', CollapsibleTab);